// this is a hack to improve DX
// TODO: figure out a better way
var _require = require("./dist/auth0"),
    Auth0 = _require.Auth0;

module.exports = {
  Auth0: Auth0
};